import { render, staticRenderFns } from "./WoTermForm.vue?vue&type=template&id=3b462c56"
import script from "./WoTermForm.vue?vue&type=script&lang=js"
export * from "./WoTermForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports